import type {PropsWithChildren} from 'react';
import type {TextProps} from '@radix-ui/themes';
import {Text as RadixText} from '@radix-ui/themes';
import {Color, useClasses} from '@gl/theme';
import {is} from '@gl/utils/predicates.js';
import * as styles from './style.module.scss';

type AllowedProps = Pick<TextProps, 'as'>;

type Props = AllowedProps & {
  color?: Color;
};

const generateColorMap = (color: Props['color']) => {
  return Object.entries(Color).reduce(
    (acc, [key, value]) => {
      const styleKey = `text${key}` as keyof typeof styles;

      if (styleKey in styles) {
        acc[styles[styleKey] as Color] = is(color, value);
      }

      return acc;
    },
    {} as Record<string, boolean>
  );
};

export const Text = ({color = 'body', ...props}: PropsWithChildren<Props>) => {
  const classNames = useClasses({
    [styles.text]: true,
    ...generateColorMap(color),
  });

  return (
    <RadixText {...props} className={classNames}>
      {props.children}
    </RadixText>
  );
};
